/**
 * Master Muscles — You May Also Like section (Shopify Recommendations API)
 */
(function () {
  'use strict';

  var CFG = window.MM_YMAL_CONFIG || {};
  var ymalFetchToken = 0;

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function formatMoney(cents) {
    if (typeof window.mmFormatMoneyHtml === 'function') {
      return window.mmFormatMoneyHtml(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return (cents / 1000).toFixed(3);
  }

  function isPurchasable(product) {
    if (window.MMRecommendations && typeof window.MMRecommendations.isProductPurchasable === 'function') {
      return window.MMRecommendations.isProductPurchasable(product);
    }
    return !!(product && product.available !== false && product.variants && product.variants.length);
  }

  function isVariantAvailable(variant) {
    if (window.MMRecommendations && typeof window.MMRecommendations.isVariantAvailable === 'function') {
      return window.MMRecommendations.isVariantAvailable(variant);
    }
    return !!(variant && variant.available === true);
  }

  function getAvailableVariants(product) {
    if (window.MMRecommendations && typeof window.MMRecommendations.getAvailableVariants === 'function') {
      return window.MMRecommendations.getAvailableVariants(product);
    }
    return (product.variants || []).filter(isVariantAvailable);
  }

  function getPricing(product, variant) {
    if (window.MMRecommendations && typeof window.MMRecommendations.getDisplayPricing === 'function') {
      return window.MMRecommendations.getDisplayPricing(product, variant);
    }
    var v = variant;
    if (!v || !isVariantAvailable(v)) {
      v = getAvailableVariants(product)[0];
    }
    if (!v) return null;
    var price = parseInt(v.price, 10) || 0;
    var compareAt = parseInt(v.compare_at_price, 10) || 0;
    var onSale = compareAt > price;
    return {
      variant: v,
      price: price,
      compareAt: onSale ? compareAt : 0,
      onSale: onSale,
      discountPct: onSale ? Math.round(((compareAt - price) / compareAt) * 100) : 0,
    };
  }

  function buildPriceHtml(pricing) {
    if (!pricing) return '';
    var html =
      '<div class="mm-ymal-card__price" data-mm-ymal-price>' +
      '<span class="mm-ymal-card__price-current">' +
      formatMoney(pricing.price) +
      '</span>';
    if (pricing.onSale) {
      html +=
        '<span class="mm-ymal-card__price-compare">' + formatMoney(pricing.compareAt) + '</span>';
    }
    html += '</div>';
    return html;
  }

  function buildCard(p) {
    if (!isPurchasable(p)) return '';
    var pricing = getPricing(p);
    if (!pricing) return '';
    var v = pricing.variant;
    var img = p.featured_image || '';
    if (typeof img === 'object' && img && img.src) img = img.src;
    var url =
      window.MMRecommendations && typeof window.MMRecommendations.productUrl === 'function'
        ? window.MMRecommendations.productUrl(p)
        : '/products/' + (p.handle || '');
    var availableVariants = getAvailableVariants(p);
    var hasVariants = availableVariants.length > 1;

    var variantHtml = '';
    if (hasVariants) {
      variantHtml =
        '<select class="mm-ymal-variant" aria-label="' +
        escapeHtml(CFG.chooseFlavour || 'Choose flavour') +
        '">' +
        '<option value="">' +
        escapeHtml(CFG.chooseFlavour || 'Choose flavour') +
        '</option>';
      availableVariants.forEach(function (variant) {
        var vimg =
          (variant.featured_image && variant.featured_image.src) ||
          (typeof p.featured_image === 'object' && p.featured_image.src) ||
          img;
        var vp = parseInt(variant.price, 10) || 0;
        var vc = parseInt(variant.compare_at_price, 10) || 0;
        variantHtml +=
          '<option value="' +
          variant.id +
          '" data-image="' +
          escapeHtml(vimg) +
          '" data-price="' +
          vp +
          '" data-compare-at="' +
          (vc > vp ? vc : 0) +
          '">' +
          escapeHtml(variant.title) +
          '</option>';
      });
      variantHtml += '</select>';
    }

    var badgeHtml = pricing.onSale
      ? '<span class="mm-ymal-card__badge" data-mm-ymal-badge>-' + pricing.discountPct + '%</span>'
      : '';

    return (
      '<article class="mm-ymal-card" data-product-id="' +
      p.id +
      '">' +
      '<a href="' +
      escapeHtml(url) +
      '" class="mm-ymal-card__img">' +
      badgeHtml +
      '<img src="' +
      escapeHtml(img) +
      '" alt="' +
      escapeHtml(p.title) +
      '" loading="lazy" width="400" height="400">' +
      '</a>' +
      '<div class="mm-ymal-card__body">' +
      '<a href="' +
      escapeHtml(url) +
      '" class="mm-ymal-card__title">' +
      escapeHtml(p.title) +
      '</a>' +
      buildPriceHtml(pricing) +
      (hasVariants ? '<div class="mm-ymal-card__variant">' + variantHtml + '</div>' : '') +
      '<button type="button" class="mm-ymal-card__add" data-variant-id="' +
      v.id +
      '" data-mm-product-id="' +
      p.id +
      '">' +
      escapeHtml(CFG.quickAdd || '+ Add') +
      '</button>' +
      '</div></article>'
    );
  }

  function bindCards(root) {
    root.querySelectorAll('.mm-ymal-variant').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var card = sel.closest('.mm-ymal-card');
        if (!card || !opt || !opt.value) return;

        var imageUrl = opt.getAttribute('data-image');
        var img = card.querySelector('.mm-ymal-card__img img');
        if (img && imageUrl) {
          img.style.opacity = '0.5';
          img.src = imageUrl;
          img.onload = function () {
            img.style.opacity = '1';
          };
        }

        var price = parseInt(opt.getAttribute('data-price'), 10) || 0;
        var compareAt = parseInt(opt.getAttribute('data-compare-at'), 10) || 0;
        var onSale = compareAt > price;
        var wrap = card.querySelector('[data-mm-ymal-price]');
        if (wrap) {
          wrap.innerHTML =
            '<span class="mm-ymal-card__price-current">' +
            formatMoney(price) +
            '</span>' +
            (onSale
              ? '<span class="mm-ymal-card__price-compare">' + formatMoney(compareAt) + '</span>'
              : '');
        }
        var badge = card.querySelector('[data-mm-ymal-badge]');
        if (onSale) {
          var pct = Math.round(((compareAt - price) / compareAt) * 100);
          if (!badge) {
            var imgLink = card.querySelector('.mm-ymal-card__img');
            if (imgLink) {
              badge = document.createElement('span');
              badge.className = 'mm-ymal-card__badge';
              badge.setAttribute('data-mm-ymal-badge', '');
              imgLink.insertBefore(badge, imgLink.firstChild);
            }
          }
          if (badge) {
            badge.textContent = '-' + pct + '%';
            badge.hidden = false;
          }
        } else if (badge) {
          badge.remove();
        }

        var addBtn = card.querySelector('.mm-ymal-card__add');
        if (addBtn) addBtn.setAttribute('data-variant-id', opt.value);
      });
    });

    root.querySelectorAll('.mm-ymal-card__add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.mm-ymal-card');
        var select = card && card.querySelector('.mm-ymal-variant');
        var variantId = select && select.value ? parseInt(select.value, 10) : parseInt(btn.getAttribute('data-variant-id'), 10);

        if (!variantId) {
          if (select) {
            select.classList.add('mm-ymal-variant--error');
            setTimeout(function () {
              select.classList.remove('mm-ymal-variant--error');
            }, 2000);
          }
          return;
        }

        var orig = btn.textContent;
        btn.disabled = true;
        btn.classList.add('is-busy');

        function onDone() {
          btn.classList.remove('is-busy');
          btn.classList.add('is-added');
          btn.textContent = CFG.added || '✓';
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-added');
            btn.textContent = orig;
          }, 1200);
        }

        function onFail() {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          btn.textContent = CFG.error || 'Error';
          setTimeout(function () {
            btn.textContent = orig;
          }, 2000);
        }

        if (window.MMCart && typeof window.MMCart.add === 'function') {
          var imgEl = card && card.querySelector('.mm-ymal-card__img img');
          window.MMCart
            .add(variantId, 1, {
              openSheet: true,
              sourceElement: btn,
              imageUrl: imgEl ? imgEl.src : null,
            })
            .then(onDone)
            .catch(onFail);
          return;
        }

        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(onDone)
          .catch(onFail);
      });
    });
  }

  function render(products) {
    var section = document.getElementById('mm-you-may-also-like');
    var grid = document.getElementById('mmYmalGrid');
    if (!section || !grid) return;

    var exclude = {};
    (CFG.excludeIds || []).forEach(function (id) {
      exclude[id] = true;
    });

    var filtered = (products || []).filter(function (p) {
      return p && p.id && !exclude[p.id] && isPurchasable(p);
    });

    if (!filtered.length) {
      section.hidden = true;
      return;
    }

    section.hidden = false;
    grid.innerHTML = filtered.map(buildCard).join('');
    bindCards(grid);
  }

  function showSkeleton(count) {
    var grid = document.getElementById('mmYmalGrid');
    if (!grid) return;
    var n = count || CFG.limit || 4;
    var html = '';
    for (var i = 0; i < n; i++) {
      html += '<div class="mm-ymal-card mm-ymal-card--skeleton" aria-hidden="true"></div>';
    }
    grid.innerHTML = html;
  }

  function init() {
    if (window.__mmYmalInitialized) return;
    window.__mmYmalInitialized = true;

    var section = document.getElementById('mm-you-may-also-like');
    if (!section) return;

    var ids = CFG.productIds || [];
    if (!ids.length) {
      section.hidden = true;
      return;
    }

    showSkeleton(CFG.limit);

    if (!window.MMRecommendations || typeof window.MMRecommendations.fetch !== 'function') {
      section.hidden = true;
      return;
    }

    var token = ++ymalFetchToken;
    window.MMRecommendations.fetch(ids, CFG.limit).then(function (products) {
      if (token !== ymalFetchToken) return;
      render(products);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
